export const preferenceKeys:any = {
    ExecutedPublication: 'ExecutedPublication',
    'items-list-catalog': 'online-catalog-grid-states',
    'items-list-browse': 'online-catalog-grid-states',
    'Items-history-attributes':'editor-history-grid-states-attributes',
    'Items-history-timeline':'editor-history-grid-states-timeline',
    'Items-history-events':'editor-history-grid-states-events'
};

export const endpoints:any = {
    ExecutedPublication: '/api/v1/user/preferences' + '/ExecutedPublication',
    'items-list-catalog': '/api/v1/user/preferences' + '/online-catalog-grid-states',
    'items-list-browse': '/api/v1/user/preferences' + '/online-catalog-grid-states',
    'Items-history-attributes': '/api/v1/user/preferences' + '/editor-history-grid-states-attributes',
    'Items-history-timeline': '/api/v1/user/preferences' + '/editor-history-grid-states-timeline',
    'Items-history-events': '/api/v1/user/preferences' + '/editor-history-grid-states-events'
};
